export default __webpack_public_path__ + "static/media/leaves.8ea2b102.ogg";